import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useQueryClient } from "@tanstack/react-query";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const queryClient=useQueryClient()
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!Cookies.get("auth_token")
  );
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  
  
  const role = userData?.user_information?.role || null;

  useEffect(() => {
    const currentToken = Cookies.get("auth_token");
    const rawUserData = Cookies.get("user_data");

    if (currentToken) setToken(currentToken);
    if (rawUserData) setUserData(JSON.parse(rawUserData));
  }, []);

 const logout = () => {
  // Clear auth cookies
  Cookies.remove("auth_token");
  Cookies.remove("user_data");
  
  // Clear all search-related cookies
  // Default Members
  Cookies.remove("default-members-page");
  
  // Quick Search
  Cookies.remove("quick-search-string");
  Cookies.remove("quick-search-input");
  Cookies.remove("quick-search-page");
  Cookies.remove("quick-search-results");
  
  // Advanced Search
  Cookies.remove("advanced-search-inputs");
  Cookies.remove("search-inputs");
  Cookies.remove("search-results");
  Cookies.remove("advanced-search-form");
  Cookies.remove("advanced-search-page");
  Cookies.remove("advanced-search-results");
  Cookies.remove("advanced-search-has-searched");
  
  // Reset state
  setIsAuthenticated(false);
  setToken(null);
  setUserData(null);
  
  // Clear TanStack Query cache
  queryClient.clear();
};

  return (
    <AuthContext.Provider
      value={{
        userData,
        logout,
        token,
        setToken,
        setUserData,
        isAuthenticated,
        setIsAuthenticated,
        role 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};